import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const devToolsAtom = atomWithStorage<boolean>('devTools', true);

export const useDevToolsSetting = () => {
  const [devTools, setDevTools] = useAtom(devToolsAtom);

  const toggleDevTools = () => {
    setDevTools((prev) => !prev);
  };

  return {
    isDevToolsEnabled: devTools,
    toggleDevTools,
  };
};
